import React from "react"

function PrivacySEO() {
  return (
    <meta name="description" content="Privacy beleid van Nabestaandenloket" />
  )
}

export default PrivacySEO
